import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ClientinfoComponent } from './clientinfo/clientinfo.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { ParticipationComponent } from './participation/participation.component';
import { DocumentsComponent } from './documents/documents.component';
import { RequestsComponent } from './requests/requests.component';
import { AlertsComponent } from './alerts/alerts.component';
import { ResourcesComponent } from './resources/resources.component';
import { ContactusComponent } from './contactus/contactus.component';
import { ProfileComponent } from './profile/profile.component';
import { RequestSummaryComponent } from './request-summary/request-summary.component';
import { PasswordComponent } from './password/password.component';
import { SurveyComponent } from './survey/survey.component';
import { FaqsComponent } from './faqs/faqs.component';
import { AlertHistoryComponent } from './alert-history/alert-history.component';
import { HelpComponent } from './help/help.component';
import { UnavailableComponent } from './unavailable/unavailable.component';
import {RedirectComponent} from './redirect/redirect.component';


const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'clientinfo/household', component: ClientinfoComponent },
  { path: 'clientinfo', component: ClientinfoComponent },
  { path: 'clientinfo/employmentsummary', component: ClientinfoComponent },
  { path: 'clientinfo/eligibilitysummary', component: ClientinfoComponent },
  { path: 'clientinfo/enrollmentsummary', component: ClientinfoComponent },
  { path: 'appointments', component: AppointmentsComponent },
  { path: 'participation', component: ParticipationComponent },
  { path: 'participation/summary', component: ParticipationComponent },
  { path: 'participation/workfare', component: ParticipationComponent},
  { path: 'documents', component: DocumentsComponent },
  { path: 'documents/notices', component: DocumentsComponent },
  { path: 'requests', component: RequestSummaryComponent },
  { path: 'requests/create', component: RequestsComponent },
  { path: 'alerts', component: AlertsComponent },
  { path: 'resources', component: ResourcesComponent },
  { path: 'contact', component: ContactusComponent },
  { path: 'profile', component: ProfileComponent },
  { path: 'help', component: HelpComponent },
  { path:'changepassword', component:PasswordComponent},
  { path:'survey', component:SurveyComponent},
  { path:'faqs', component:FaqsComponent},
  { path:'alerts/history', component:AlertHistoryComponent},
  { path:'unavailable', component:UnavailableComponent},
  { path:'redirect/:token', component:RedirectComponent}
]


@NgModule({
  exports: [ RouterModule ],
  imports: [ RouterModule.forRoot(routes) ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts